import React from "react";
import { Modal, List, Typography, Select } from "antd";

const { Text } = Typography;

const LINE_COUNT_OPTIONS = [
  { value: 20, label: "20 行" },
  { value: 50, label: "50 行" },
  { value: 100, label: "100 行" },
  { value: 200, label: "200 行" },
];

/**
 * 假人日志模态框
 */
const LogsModal = ({ visible, bot, logs, loading, lineCount, onLineCountChange, onCancel }) => {
  if (!bot) return null;

  return (
    <Modal
      title={`假人日志 - ${bot.name || ""}`}
      open={visible}
      onCancel={onCancel}
      footer={null}
      className="botcontrol-modal"
      width={800}
    >
      <div className="logs-modal-content">
        <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 13, color: "#666" }}>显示行数：</span>
          <Select
            value={lineCount}
            onChange={onLineCountChange}
            options={LINE_COUNT_OPTIONS}
            size="small"
            style={{ width: 100 }}
          />
        </div>
        <div
          style={{
            height: "400px",
            overflow: "auto",
            padding: "10px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            fontFamily: "monospace",
          }}
        >
          <List
            size="small"
            dataSource={logs}
            loading={loading}
            renderItem={(log) => (
              <List.Item style={{ border: "none", padding: "4px 0" }}>
                <Text style={{ fontSize: "12px" }}>{log}</Text>
              </List.Item>
            )}
            locale={{ emptyText: "暂无日志" }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogsModal;
